import { useEffect, useMemo } from "react";

import BasicDataTable from "../../components/DataTable/BasicDataTable";
import { cashWithdrawalColumns } from "../../features/cash/cashWithdrawalColumns";

import { useCashMovements } from "../../hooks/cash/useCashMovements";
import { useCashSession } from "../../hooks/cash/useCashSession";

import { CashMovementType } from "../../types/cash/CashMovementType";

const CashWithdrawalHistory = () => {

  const { movements, getSessionMovements } = useCashMovements();
  const { activeSession } = useCashSession();

  const columns = useMemo(() => cashWithdrawalColumns, []);

  /**
   * 📜 Cargar solo retiros
   */
  useEffect(() => {

    if (!activeSession?.id) return;

    getSessionMovements(
      activeSession.id,
      [CashMovementType.WITHDRAWAL]
    );

  }, [activeSession?.id]);

  /**
   * ❌ SIN SESIÓN → NO RENDERIZA
   */
  if (!activeSession) {
    return null;
  }

  return (

    <BasicDataTable
      columns={columns}
      data={movements}
      noDataMessage="No hay retiros registrados."
    />

  );

};

export default CashWithdrawalHistory;